module.exports = __webpack_public_path__ + "static/media/more-vertical.a56322e6.svg";